import 'select2';

$.fn.select2.defaults.set('amdLanguageBase', 'select2/i18n/')
$.fn.select2.defaults.set('language', 'de')

$('.select2').select2({
    language: 'de',
})

